module.exports = __webpack_public_path__ + "img/illustration-working.5029d049.svg";